import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  min-height: 100vh;
  padding: 24px;

  h1 {
    margin-bottom: 8px;
    color: #1a1a1a;
    font-size: 28px;
    font-weight: 600;
  }

  @media only screen and (max-width: 1024px) {
    padding: 70px 16px 16px;
  }
`;

export const FiltersContainer = styled.div`
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;

  .ant-form-item {
    margin-bottom: 16px;
  }

  .ant-form-item-label > label {
    font-weight: 500;
    color: #262626;
  }
`;

export const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
`;

export const StatCard = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  padding: 20px;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.2s,
    box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .stat-value {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 4px;
    word-break: break-word;
  }

  .stat-label {
    font-size: 14px;
    opacity: 0.9;
    font-weight: 400;
  }

  &:nth-child(2) {
    background: linear-gradient(135deg, #f28c28 0%, #f5576c 100%);
  }

  &:nth-child(3) {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  }

  &:nth-child(4) {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  }
`;
